/**
 * COMMERCE-WORKSPACE-FRAMEWORK-000001 — quick filter chip bar.
 */
import type { QuickFilterOption } from './types';

export function QuickFilterBar({
  filters,
  value,
  onChange,
  ariaLabel = 'Quick filters',
}: {
  filters: QuickFilterOption[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
}) {
  return (
    <div className="flex w-full flex-wrap items-center gap-2" role="group" aria-label={ariaLabel}>
      {filters.map((f) => {
        const on = value === f.value;
        return (
          <button
            key={f.id}
            type="button"
            onClick={() => onChange(f.value)}
            aria-pressed={on}
            className={`min-h-11 rounded-[var(--shell-radius-md)] border px-3 text-sm font-medium transition-colors duration-[var(--shell-motion-fast)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--shell-focus-ring)] ${
              on
                ? 'border-[var(--shell-accent)] bg-[var(--shell-accent-muted)] text-[var(--shell-accent)]'
                : 'border-[var(--shell-border)] bg-[var(--shell-surface-elevated)] text-[var(--shell-fg-muted)] hover:bg-[var(--shell-hover)]'
            }`}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
